export enum MAP_OPTIONS_TILE_LAYER_NAMES {
  CLASSIC = 'classic',
  SATELLITE = 'satellite'
}
